import { Avatar, ConfigProvider, Form, InputNumber, Space } from "antd";
import cx from "classnames";

import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const FormInputNumber = ({
    label = "",
    name = "",
    placeholder = null,
    size = "middle",
    onChange = () => { },
    onFocus = () => { },
    onBlur = () => { },
    className = "",
    subclassName = "",
    required = false,
    disabled = false,
    vertical = true,
    fontWeight = "",
    labelFontSize = "14px",
    formatter = null,
    parser = null,
    width = "100%",
    precision = 2,
    max = null,
    min = null,
    controls = true,
    direction = 'ltr',
    maxLength = null,
    textAlign = "",
    addonBefore = null,
    suffix = null,
    suffixText = "",
    layoutType = "vertical",
    rules = null,
    dependencies = undefined,
    style = {},
    variant = "outlined"
}) => {

    const [formatReset, setFormatReset] = useState(false)

    const handleChange = (value) => {
        console.log("handleChange", value);
        setFormatReset(true)
        onChange(value);

    };
    const ref = useRef()

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        }
    }

    return (
        <ConfigProvider direction={direction} theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },

            },
        }}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues[name] !== curValues[name]}>
                {(form) => (
                    <>
                        {layoutType === "vertical" ? (
                            <Form.Item
                                {...layout}
                                labelAlign="left"
                                label={label}
                                name={name}
                                required={required}
                                {...(dependencies && { dependencies })}
                                style={{ fontWeight, padding: 0, margin: 0 }}
                                rules={rules
                                    ? rules
                                    : [
                                        {
                                            required,
                                            message:
                                                i18n.language === "th"
                                                    ? `กรุณากรอก ${label}`
                                                    : `${label} is required`,
                                        },
                                    ]}
                            >
                                <InputNumber
                                    id={name}
                                    ref={ref}
                                    controls={controls}
                                    className={cx(styles.input, subclassName)}
                                    name={name}
                                    placeholder={placeholder ?? label}
                                    disabled={disabled}
                                    size={size}
                                    variant={variant}
                                    precision={precision}
                                    min={min}
                                    max={max}
                                    addonBefore={addonBefore}
                                    onChange={handleChange}
                                    suffix={suffix}
                                    formatter={
                                        formatReset && formatter
                                            ? formatter
                                            : (value, t) => {
                                                if (formatReset) return value;
                                                if (t.userTyping) return value == 0 ? 0 : value;
                                                return form.getFieldValue([name]) == null
                                                    ? ""
                                                    : get2DecimalPointsWithCommas(value, precision);
                                            }
                                    }
                                    parser={
                                        parser
                                            ? parser
                                            : (value) =>
                                                !value || value == 0
                                                    ? 0
                                                    : value.replace(/[^\d.]/g, "")
                                    }
                                    onBlur={(e) => {
                                        onBlur(e);
                                        setFormatReset(false)
                                    }}
                                    onFocus={() => {
                                        const currentValue = ref.current?.value;
                                        onFocus(currentValue)
                                        if (currentValue == 0) {
                                            form.setFieldValue([name], null);
                                        }
                                    }}
                                    style={{ width, textAlignLast: textAlign }}
                                />
                            </Form.Item>
                        ) : (
                            <Form.Item
                                name={name}
                                requiredMark={false}
                                {...(dependencies && { dependencies })}
                                rules={rules
                                    ? rules
                                    : [
                                        {
                                            required,
                                            message:
                                                i18n.language === "th"
                                                    ? `กรุณากรอก ${label}`
                                                    : `${label} is required`,
                                        },
                                    ]}
                                label={
                                    <span
                                        style={{
                                            fontSize: labelFontSize,
                                            display: "flex",
                                            alignItems: "center",
                                            height: "32px",
                                        }}
                                    >
                                        {label}
                                    </span>
                                }
                            >
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "32px",
                                    gap: "12px"
                                }}>
                                    <Form.Item name={name} noStyle>
                                        <InputNumber
                                            id={name}
                                            ref={ref}
                                            variant={variant}
                                            controls={controls}
                                            className={cx(styles.input, subclassName)}
                                            name={name}
                                            placeholder={placeholder ?? label}
                                            disabled={disabled}
                                            size={size}
                                            precision={precision}
                                            min={min}
                                            max={max}
                                            addonBefore={addonBefore}
                                            onChange={handleChange}
                                            suffix={suffix}
                                            formatter={
                                                formatReset && formatter
                                                    ? formatter
                                                    : (value, t) => {
                                                        if (formatReset) return value;
                                                        if (t.userTyping) return value == 0 ? 0 : value;
                                                        return form.getFieldValue([name]) == null
                                                            ? ""
                                                            : get2DecimalPointsWithCommas(value, precision);
                                                    }
                                            }
                                            parser={
                                                parser
                                                    ? parser
                                                    : (value) =>
                                                        !value || value == 0
                                                            ? 0
                                                            : value.replace(/[^\d.]/g, "")
                                            }
                                            onBlur={(e) => {
                                                onBlur(e);
                                                setFormatReset(false)
                                            }}
                                            onFocus={() => {
                                                const currentValue = ref.current?.value;
                                                onFocus(currentValue)

                                                if (currentValue == 0) {
                                                    form.setFieldValue([name], null);
                                                }
                                            }}
                                            style={{ width, textAlignLast: textAlign }}
                                        />
                                    </Form.Item>
                                    {suffixText && (
                                        <span
                                            style={{
                                                fontSize: labelFontSize,
                                                display: "flex",
                                                alignItems: "center",
                                                height: "32px",
                                            }}
                                        >
                                            {suffixText}
                                            {required && (
                                                <span style={{ color: "red", marginLeft: 4 }}>*</span>
                                            )}
                                        </span>
                                    )}
                                </div>
                            </Form.Item>
                        )}
                    </>
                )
                }
            </Form.Item >
        </ConfigProvider >
    );
};

export default FormInputNumber;
